import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgLinkIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.6 122.88"
    xmlSpace="preserve"
    ref={ref}
  >
    <path d="M110.6 72.58c0-3.19 2.59-5.78 5.78-5.78 3.19 0 5.78 2.59 5.78 5.78v33.19c0 4.71-1.92 8.99-5.02 12.09a17.06 17.06 0 0 1-12.09 5.02H17.11c-4.71 0-8.99-1.92-12.09-5.02A17.06 17.06 0 0 1 0 105.77V17.19C0 12.48 1.92 8.2 5.02 5.1 8.12 2 12.4.08 17.11.08h32.98c3.19 0 5.78 2.59 5.78 5.78 0 3.19-2.59 5.78-5.78 5.78H17.11c-1.52 0-2.9.63-3.91 1.63a5.511 5.511 0 0 0-1.63 3.91v88.58c0 1.52.63 2.9 1.63 3.91a5.511 5.511 0 0 0 3.91 1.63h87.95c1.52 0 2.9-.63 3.91-1.63s1.63-2.39 1.63-3.91V72.58zm1.82-55.12L54.01 76.6a5.776 5.776 0 0 1-8.16.07 5.776 5.776 0 0 1-.07-8.16l56.16-56.87H78.56c-3.19 0-5.78-2.59-5.78-5.78 0-3.19 2.59-5.78 5.78-5.78h26.5c5.12 0 11.72-.87 15.65 3.1 2.48 2.51 1.93 22.52 1.61 34.11-.08 3-.15 5.29-.15 6.93 0 3.19-2.59 5.78-5.78 5.78-3.19 0-5.78-2.59-5.78-5.78 0-.31.08-3.32.19-7.24.16-6.04 1.13-14.04 1.62-19.52z" />
  </svg>
);
const ForwardRef = forwardRef(SvgLinkIcon);
export default ForwardRef;
